import {useCallback, useState} from 'react';

import {MapRef} from '~types/Map';

export default function usePitchToggle(mapRef: MapRef, pitch = 40, bearing = 0) {
    const [is3D, setIs3D] = useState(false);

    return {
        is3D,
        toggle3D: useCallback(() => {
            if (!mapRef.current) return;

            const flat = mapRef.current.getPitch() === 0;
            setIs3D(flat);

            if (flat) {
                mapRef.current.easeTo({pitch, bearing});
            } else {
                mapRef.current.easeTo({pitch: 0, bearing: 0});
            }
        }, [pitch, bearing]),
    };
}
